import React from 'react';
import Proptypes from 'prop-types';
import { createLocaleTextGetter } from '../util';

function localize(Component) {
  return class Localize extends React.Component {
    static propTypes = {
      data: Proptypes.object,
      pageContext: Proptypes.shape({
        locale: Proptypes.string,
      }),
    };

    constructor(props) {
      super(props);

      this.getLocalizedContent = createLocaleTextGetter(
        // eslint-disable-next-line react/destructuring-assignment
        this.props.pageContext.locale
      );
    }

    render() {
      return (
        <Component
          {...this.props}
          // eslint-disable-next-line react/destructuring-assignment
          data={this.getLocalizedContent(this.props.data)}
        />
      );
    }
  };
}

export default localize;
